"use client";

import { Button } from "@repo/ui";
import Link from "next/link";
import { useParams } from "next/navigation";
import LoadMore from "../LoadMore";

type ChipLinksProps = {
  data?: { title: string; slug: string }[];
};

const ChipLinks = ({ data = [] }: ChipLinksProps) => {
  const { country } = useParams<{ country: string }>();
  return (
    <LoadMore
      className="flex flex-wrap gap-3"
      items={data}
      initialVisibleItems={10}
      render={(item, index) => (
        <Button
          key={index + item.slug}
          render={
            <Link
              href={
                country
                  ? `/${country}/course/${item.slug}`
                  : `/course/${item.slug}`
              }
            />
          }
          variant="outlined"
          color="primary"
          roundedFull
          size="medium"
          className="!whitespace-normal !py-2 !h-auto"
        >
          {item.title}
        </Button>
      )}
    />
  );
};

export default ChipLinks;
